module.exports = __webpack_public_path__ + "media/luxury-2026/conyers-family-960-9a2ba9b0.jpg";